export default {"src":"/_next/static/media/ticket_icon.f99eb305.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};